import PropTypes from "prop-types";
import { useEffect, useRef } from "react";
import { FileUploader } from "react-drag-drop-files";

// react-drag-drop-files wraps a real file input in a <label role="button">:
// a control inside a control, which screen readers announce twice and axe
// reports (nested-interactive). Dropping the role leaves the native file
// input, named by the label's text, as the one control; click, keyboard and
// drag-and-drop work as before. Same props as FileUploader, plus the input's
// own name and description: Tab reached an input read as just "INPUT" (CMS
// review round 3, georges-14), and the library puts its ariaLabel on the label.
const AccessibleUploader = ({ children, inputLabel, inputDescribedBy, ...props }) => {
  const box = useRef(null);
  useEffect(() => {
    box.current?.querySelectorAll('label[role="button"]').forEach((label) => label.removeAttribute("role"));
    const input = box.current?.querySelector('input[type="file"]');
    if (!input) return;
    if (inputLabel) input.setAttribute("aria-label", inputLabel);
    if (inputDescribedBy) input.setAttribute("aria-describedby", inputDescribedBy);
  });
  return (
    <div ref={box}>
      <FileUploader {...props}>{children}</FileUploader>
    </div>
  );
};

AccessibleUploader.propTypes = {
  children: PropTypes.node,
  /** The file input's accessible name, said when Tab reaches it. */
  inputLabel: PropTypes.string,
  /** Ids of the hint and error the file input is described by. */
  inputDescribedBy: PropTypes.string,
};

export default AccessibleUploader;
